var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row margin-bottom-2x"},[_c('div',{staticClass:"col-xs-12 col-sm-4 text-right-sm text-muted line-height-3x"},[_vm._t("label")],2),_c('div',{staticClass:"col-xs-12 col-sm-6 no-padding-sm"},[_vm._t("field")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }